module.exports = __webpack_public_path__ + "static/media/clothes_title_ko@3x.e9d57c06.png";